export type UpdateEnvironmentCopyRequestResponse = {};
